import {ChangeDetectionStrategy, Component, inject, input, OnInit} from '@angular/core';
import {ProductPackageFile} from "../../types/product-package-modal.types";
import {ProductPackageFilesStateService} from "../../services/product-package-files-state.service";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {productPackageFilesResourceType} from "../../configs/product-package-modal-config";
import {ProductPackageModalService} from "../../services/product-package-modal.service";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-product-package-files]',
  standalone: true,
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './product-package-files.component.html',
  styleUrl: './product-package-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPackageFilesComponent implements OnInit {
  productPackageId = input<number>(0);
  isEditModeActive = input<boolean>(false);

  private productPackageFilesStateService: ProductPackageFilesStateService = inject(ProductPackageFilesStateService);
  private productPackageModalService: ProductPackageModalService = inject(ProductPackageModalService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<ProductPackageFile> {
    return this.productPackageFilesStateService.getProductPackageFilesById(this.productPackageId());
  }

  public async handleDelete(isImage: boolean, file: ProductPackageFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: productPackageFilesResourceType.path,
      id: file.id
    };

    this.productPackageModalService.deleteFile(deleteFileParams)
      .then(() => this.productPackageFilesStateService.deleteFileById(file.id, this.productPackageId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: productPackageFilesResourceType.path,
      body: {
        fileId: fileId,
        productPackageId: parentId
      }
    };

    await this.productPackageModalService.attachFile<ProductPackageFile>(attachFileParams)
      .then((data) => this.productPackageFilesStateService.updateProductPackageFilesState(this.productPackageId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: productPackageFilesResourceType.path,
      params: { productPackageId: this.productPackageId() }
    };

    await this.productPackageModalService.getFiles(params)
      .then((data) => this.productPackageFilesStateService.setProductPackageFilesState(this.productPackageId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
